import { HumanResourceService } from './../../services/human-resource.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  NgbDate,
  NgbDateStruct,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import { AppPattern } from 'src/app/services/app-pattern';
import * as moment from 'moment';
import { DiaryReportService } from 'src/app/services/diary-report.service';
import { MasterDataCommon } from 'src/app/master-data/master-data.common';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-my-diaries',
  templateUrl: './my-diaries.component.html',
  styleUrls: ['./my-diaries.component.css'],
})
export class MyDiariesComponent implements OnInit {
   page=1;
  pageSize=10;
  pageLength=0;
  showRow = false;
  diaryForm;
  clientList: any;
  reports;
  showReports = false;
  employeeFormList = [];
  empType = 'Active';
  formSubmitted = false;
  formErrors = MasterDataCommon.myDiariesStdReportFormErrors;
  formValidationMessages =
    MasterDataCommon.myDiariesStdReportFormValidationMessages;
  fdate;
  tdate;
  config: any;
  collection = { count: 60, reports: [] };
  totalDebitHr;
  totalDebitMin ;
  totalDebitHrMin;
  totalCreditHr;
  totalCreditMin;
  totalNoOfHr;
  totalNoOfMin;
  totalAmount;
  isClientSelected = false;
  selectClient;
  userFname;
  userLname;
  userMname;
  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private humanResourceService: HumanResourceService,
    private diaryReportService: DiaryReportService
  ) {
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.reports,
    };
  }

  pageChanged(event) {
    if (this.pageLength == event) {
      this.showRow = true;
    } else {
      this.showRow = false;
    }
  }

  ngOnInit(): void {
    this.userFname = localStorage.getItem('userFname');
    this.userLname = localStorage.getItem('userLname');
    this.userMname=localStorage.getItem('userMname');
    this.initDiaryForm();
  }

  initDiaryForm() {
    this.diaryForm = this.fb.group({
      fromDate: ['', [Validators.required]],
      toDate: ['', [Validators.required]],
      clients: ['', [Validators.required]],
    });
  }



  onViewReport() {
       this.showRow = false;
      this.formSubmitted = true;
      this.logValidationErrors(this.diaryForm);
      if (this.diaryForm.valid) {
      var emp = localStorage.getItem('id');
      var status = 'Active';
      this.fdate =
        this.diaryForm.value.fromDate.year +
        '-' +
        this.diaryForm.value.fromDate.month +
        '-' +
        this.diaryForm.value.fromDate.day;
      this.tdate =
        this.diaryForm.value.toDate.year +
        '-' +
        this.diaryForm.value.toDate.month +
        '-' +
        this.diaryForm.value.toDate.day;

      var clients = [];
      for (let i = 0; i < this.diaryForm.value.clients.length; i++) {
        clients.push(this.diaryForm.value.clients[i].id);
      }
      var cidStr = clients.toString();
      this.diaryReportService
        .getReport1(this.fdate, this.tdate, emp, status, cidStr)
        .subscribe(
          (resp) => {
            this.reports = resp;
            console.log('diary report',this.reports);
            this.showReports = true;
            this.pageLength = Math.ceil(this.reports.length / 10);
            if(this.pageLength==1){
             this.showRow=true;
             }else{
          this.showRow=false;
        }
            this.fndTotalCount(this.reports);
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  loadLookupForManageProfile() {
    console.log('loadLookupForManageProfile');
    this.fdate =
    this.diaryForm.value.fromDate.year +
    '-' +
    this.diaryForm.value.fromDate.month +
    '-' +
    this.diaryForm.value.fromDate.day;

  this.tdate =
    this.diaryForm.value.toDate.year +
    '-' +
    this.diaryForm.value.toDate.month +
    '-' +
    this.diaryForm.value.toDate.day;

    this.humanResourceService
      .getClientByDate(localStorage.getItem('id'), this.fdate,this.tdate)
      .subscribe((res: any) => {
        console.log('client list',res);
        this.clientList = res;
      });
  }

  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  fndTotalCount(report) {
  this.totalDebitHr = 0;
  this.totalDebitMin = 0;
  this.totalDebitHrMin = 0;
  this.totalCreditHr = 0;
  this.totalCreditMin = 0;
  this.totalNoOfHr = 0;
  this.totalNoOfMin = 0;
  this.totalAmount = 0;
    let reportArrayLength = report.length;
    for (let i = 0; i < report.length; i++) {
      this.totalDebitHr += report[i].debitHrs;
      this.totalDebitMin += report[i].debitMin / 60;

      this.totalCreditHr += report[i].creditHrs;
      this.totalCreditMin += report[i].creditMin / 60;

      this.totalNoOfHr += report[i].noOfHoursHr;
      this.totalNoOfMin += report[i].noOfHoursMin / 60;
      this.totalAmount += report[i].amount;
    }
  }

  selectAllClient(clients) {
    if (clients._selected) {
      this.diaryForm.controls['clients'].setValue(this.clientList);
      clients._selected = true;
    }
    if (clients._selected == false) {
      this.diaryForm.controls['clients'].setValue([]);
    }
  }

  exportToExcelClick(){
    var emp = localStorage.getItem('id');
    this.fdate =
      this.diaryForm.value.fromDate.year +
      '-' +
      this.diaryForm.value.fromDate.month +
      '-' +
      this.diaryForm.value.fromDate.day;
    this.tdate =
      this.diaryForm.value.toDate.year +
      '-' +
      this.diaryForm.value.toDate.month +
      '-' +
      this.diaryForm.value.toDate.day;

    var clients = [];
    for (let i = 0; i < this.diaryForm.value.clients.length; i++) {
      clients.push(this.diaryForm.value.clients[i].id);
    }
    var cidStr = clients.toString();
    this.diaryReportService
      .getReportForExportToExcel(this.fdate, this.tdate, emp, cidStr)
      .subscribe(
        (resp:any) => {
          const blob = new Blob([resp]); // you can change the type
          var downloadURL= window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.download = "MyDiaryReport.xlsx";
          link.click();
        });
  }
}
